// extracted by mini-css-extract-plugin
export default {"root":"empty-state_root__7Y+3b","icon":"empty-state_icon__aLM2X"};